import { jsPDF } from "jspdf";

const GOLD = [212, 175, 55], INK = [9, 9, 11], MUTED = [113, 113, 122], RED = [220, 38, 38], GREEN = [16, 160, 110];
const clean = (s) => String(s ?? "").replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"').replace(/[\u2013\u2014]/g, "-").replace(/\u2026/g, "...").replace(/[^\x20-\x7E\u00A0-\u00FF]/g, "");

const logoData = () => fetch("/logo.png").then((r) => r.blob()).then((b) => new Promise((ok) => { const fr = new FileReader(); fr.onload = () => ok(fr.result); fr.readAsDataURL(b); })).catch(() => null);

const buildFixPdf = async (r, { elitePrice } = {}) => {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth(), H = doc.internal.pageSize.getHeight(), M = 48;
  let y = 0;
  const ensure = (h) => { if (y + h > H - 70) { doc.addPage(); y = M; } };

  doc.setFillColor(...INK); doc.rect(0, 0, W, 110, "F");
  doc.setFillColor(...GOLD); doc.rect(0, 110, W, 3, "F");
  const logo = await logoData();
  if (logo) doc.addImage(logo, "PNG", M, 30, 166, 33);
  doc.setTextColor(...GOLD); doc.setFont("helvetica", "bold"); doc.setFontSize(9);
  doc.text("FREE ATS RESUME SCAN", W - M, 42, { align: "right" });
  doc.setTextColor(255, 255, 255); doc.setFontSize(20); doc.text("Your ATS Fix List", W - M, 66, { align: "right" });
  doc.setTextColor(170, 170, 178); doc.setFont("helvetica", "normal"); doc.setFontSize(9);
  doc.text(`${new Date().toLocaleDateString([], { year: "numeric", month: "long", day: "numeric" })}${r.email ? `  |  ${clean(r.email)}` : ""}`, W - M, 84, { align: "right" });

  y = 150;
  const score = Math.round(r.score ?? 0);
  doc.setDrawColor(230, 230, 232); doc.setLineWidth(8); doc.circle(M + 40, y + 20, 34, "S");
  doc.setDrawColor(...GOLD); doc.setLineWidth(8);
  const steps = Math.round((score / 100) * 60);
  for (let i = 0; i < steps; i++) { const a1 = -Math.PI / 2 + (i / 60) * 2 * Math.PI, a2 = -Math.PI / 2 + ((i + 1) / 60) * 2 * Math.PI; doc.line(M + 40 + 34 * Math.cos(a1), y + 20 + 34 * Math.sin(a1), M + 40 + 34 * Math.cos(a2), y + 20 + 34 * Math.sin(a2)); }
  doc.setTextColor(...INK); doc.setFont("helvetica", "bold"); doc.setFontSize(24); doc.text(String(score), M + 40, y + 29, { align: "center" });
  const verdict = clean(r.verdict || (score >= 80 ? "Likely to pass" : score >= 60 ? "Borderline" : "At risk of being filtered"));
  doc.setFontSize(9); doc.setTextColor(...GOLD); doc.text("ATS READINESS", M + 100, y + 2);
  doc.setFontSize(18); doc.setTextColor(...INK); doc.text(verdict, M + 100, y + 24);
  if (r.summary) { doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(...MUTED); doc.text(doc.splitTextToSize(clean(r.summary), W - M * 2 - 100).slice(0, 3), M + 100, y + 42); }
  y += 90;

  const heading = (t) => { ensure(40); doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor(...GOLD); doc.text(t.toUpperCase(), M, y); doc.setDrawColor(...GOLD); doc.setLineWidth(0.8); doc.line(M, y + 6, W - M, y + 6); y += 26; };

  if (r.checks?.length) {
    heading("What we checked");
    r.checks.forEach((c) => {
      const note = c.note ? doc.splitTextToSize(clean(c.note), W - M * 2 - 90) : [];
      ensure(22 + note.length * 13);
      doc.setFillColor(...(c.ok ? GREEN : RED)); doc.roundedRect(M, y - 10, 42, 15, 7, 7, "F");
      doc.setTextColor(255, 255, 255); doc.setFont("helvetica", "bold"); doc.setFontSize(7.5); doc.text(c.ok ? "PASS" : "FIX", M + 21, y, { align: "center" });
      doc.setTextColor(...INK); doc.setFontSize(11); doc.text(clean(c.label), M + 56, y);
      if (note.length) { doc.setFont("helvetica", "normal"); doc.setFontSize(9.5); doc.setTextColor(...MUTED); doc.text(note, M + 56, y + 14); }
      y += 24 + note.length * 13;
    });
    y += 6;
  }

  if (r.fixes?.length) {
    heading("Your top fixes");
    r.fixes.forEach((f, i) => {
      const lines = doc.splitTextToSize(clean(f), W - M * 2 - 36);
      ensure(lines.length * 15 + 12);
      doc.setFillColor(51, 41, 13); doc.circle(M + 10, y - 4, 10, "F");
      doc.setTextColor(...GOLD); doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.text(String(i + 1), M + 10, y - 0.5, { align: "center" });
      doc.setTextColor(...INK); doc.setFont("helvetica", "normal"); doc.setFontSize(11); doc.text(lines, M + 32, y);
      y += lines.length * 15 + 12;
    });
  }

  ensure(150); y += 10;
  const url = `${window.location.origin}/upgrade?tier=elite&ref=pdf`;
  doc.setFillColor(...INK); doc.roundedRect(M, y, W - M * 2, 130, 12, 12, "F");
  doc.setDrawColor(...GOLD); doc.setLineWidth(1.2); doc.roundedRect(M, y, W - M * 2, 130, 12, 12, "S");
  doc.setTextColor(...GOLD); doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.text("RECOMMENDED FOR YOU  |  RPOPRO ELITE", M + 22, y + 28);
  doc.setTextColor(255, 255, 255); doc.setFontSize(17); doc.text(score >= 80 ? "Turn a good resume into interviews." : `Take your ${score} score to 90+.`, M + 22, y + 52);
  doc.setFont("helvetica", "normal"); doc.setFontSize(10); doc.setTextColor(200, 200, 206);
  doc.text("AI rewrites every weak bullet  |  Tailored resume for each job  |  Auto-Apply + mock interviews", M + 22, y + 72);
  doc.setFillColor(...GOLD); doc.roundedRect(M + 22, y + 88, 190, 28, 14, 14, "F");
  doc.setTextColor(...INK); doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.text(`Get Elite${elitePrice ? ` - ${elitePrice}/mo` : ""}`, M + 117, y + 106, { align: "center" });
  doc.link(M + 22, y + 88, 190, 28, { url });
  doc.setTextColor(...GOLD); doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.textWithLink("Start with a free 7-day Elite trial", M + 230, y + 106, { url });

  const pages = doc.getNumberOfPages();
  for (let p = 1; p <= pages; p++) {
    doc.setPage(p); doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(...MUTED);
    doc.text("Scores reflect RPOPRO's own evaluation criteria and are not a guarantee of interviews or offers.", M, H - 30);
    doc.text(`rpopro.co  |  ${p}/${pages}`, W - M, H - 30, { align: "right" });
  }
  return doc;
};

export const fixPdfName = (r) => `RPOPRO-ATS-fix-list-${Math.round(r.score ?? 0)}.pdf`;
export const downloadFixPdf = async (r, opts) => (await buildFixPdf(r, opts)).save(fixPdfName(r));
export const fixPdfBase64 = async (r, opts) => (await buildFixPdf(r, opts)).output("datauristring").split(",")[1];
